import React, { Component, Fragment } from "react";
import Profile from "../../../containers/Profile";
import Wallets from "../../../containers/Wallets";
import NetworksAddresses from "../../../containers/NetworksAddresses";
import Transactions from "../../../containers/Transactions";
import BankAccounts from "../../../containers/BankAccounts";
import { application } from "../../../constants/configs";
import UserReferrals from "../../../containers/UserReferrals";
import { Section, SectionsSpy } from "react-smart-sections";
import BankInfo from "../../../containers/BankInfo";
import Orders from "../../../containers/Orders";
import Trades from "../../../containers/Trades";
import Tickets from "../../../containers/Tickets";
import KycInfo from "../../../containers/KycInfo";
import Notes from "../../../containers/Notes";
import Rbac from "../../../components/Rbac";
import i18n from "../../../services/i18n";
import Api from "../../../services/Api";
import ZarinpalTransfers from "../../../containers/ZarinpalTransfers";
import UserGifts from "../../../containers/UserGifts";
import UserBonuses from "../../../containers/UserBonuses";
// import UserBots from "../../../containers/UserBots";
import UserNotifications from "../../../containers/UserNotifications";
import UserPrivateNotifications from "../../../containers/UserPrivateNotifications";
import UserAlerts from "../../../containers/UserAlerts";
import WalletHistory from "../../../containers/WalletHistory";

class Info extends Component {
  constructor(props) {
    super(props);
    this.state = {
      profile: null,
      settings: null,
      wallets: null,
    };
    this.defaultSection =
      props.location.state && props.location.state.section
        ? props.location.state.section
        : null;
    this.transactionsInstance = React.createRef();
  }

  async componentDidMount() {
    await this.fetchData();
  }

  fetchData = async () => {
    await Promise.all([
      this.fetchProfile(),
      this.fetchWallets(),
      this.fetchGeneralSettings(),
    ]);
  };

  fetchWallets = async () => {
    const { id } = this.props.match.params;
    try {
      const { data } = await Api.invoke("GET", "/admin-ui/user-wallets", null, {
        params: {
          userId: id,
        },
      });
      this.setState({
        wallets: data,
      });
      return data;
    } catch (e) {
      console.log("error: ", e);
    }
  };

  fetchProfile = async () => {
    const { id } = this.props.match.params;
    try {
      const { data } = await Api.invoke("GET", "/admin-ui/user-profile", null, {
        params: {
          userId: id,
        },
      });
      this.setState({
        profile: data,
      });
    } catch (e) {
      console.log("error: ", e);
    }
  };

  fetchGeneralSettings = async () => {
    try {
      const { data } = await Api.invoke("GET", "/settings", null, {
        api: { authenticate: false },
      });
      this.setState({
        settings: data,
      });
    } catch (e) {
      console.log("error: ", e);
    }
  };

  updateTransactions = async () => {
    if (this.transactionsInstance && this.transactionsInstance.current) {
      await this.transactionsInstance.current.fireFetchData();
    }
  };

  render() {
    const { profile, settings, wallets } = this.state;
    const { id } = this.props.match.params;
    const { state } = this.props.location;
    const data = { ...state, id };

    if (!profile) {
      return <div className="loading" />;
    }

    return (
      <Fragment>
        <div className="sectionsSpy">
          <SectionsSpy
            render={(sections) => {
              return (
                <div className="navigation bg-white d-flex flex-1 justify-content-around align-items-center">
                  {sections.map((section) => {
                    if (
                      this.defaultSection &&
                      section.name === this.defaultSection
                    ) {
                      section.scroll();
                      this.defaultSection = null;
                    }
                    return (
                      <span
                        key={section.name}
                        onClick={section.scroll}
                        className="flex-1 py-3 px-1 text-center border-left cursor-pointer bg-white"
                        style={{ fontSize: 11 }}
                      >
                        {i18n.t(section.name)}
                      </span>
                    );
                  })}
                </div>
              );
            }}
          />
        </div>
        <Rbac permission="view_profile">
          <Section name="User Account">
            <Profile
              info={{
                ...data,
                ...profile,
              }}
              fetchProfile={this.fetchProfile}
            />
          </Section>
        </Rbac>
        <Rbac permission="view_user-descriptions">
          <Section name="Notes">
            <Notes userId={id} />
          </Section>
        </Rbac>

        <Rbac permission="view-user-transactions-history">
          <Section name="Wallet History">
            <WalletHistory userId={id} />
          </Section>
        </Rbac>

        <Rbac permission="view_user-kyc">
          <Section name="Identity Authentication">
            <KycInfo
              userId={id}
              profile={profile}
              fetchProfile={this.fetchProfile}
            />
          </Section>
        </Rbac>
        <Rbac permission="view_user-wallets">
          <Section name="Wallets">
            <Wallets
              userId={id}
              wallets={wallets}
              fetchWallets={this.fetchWallets}
              updateTransactions={this.updateTransactions}
              firstName={profile ? profile.firstName : null}
              lastName={profile ? profile.lastName : null}
            />
          </Section>
        </Rbac>
        <Rbac permission="view_user-wallets">
          <Section name="Wallets Addresses">
            <NetworksAddresses userId={id} />
          </Section>
        </Rbac>
        {application.platformName === "zarindax" &&
          !!profile &&
          !!profile.zarinpalId && (
            <Rbac permission="view_transfer-wallet-balance">
              <Section name="Zarinpal Transfers">
                <ZarinpalTransfers userId={id} />
              </Section>
            </Rbac>
          )}
        <Rbac permission="view_user-deposits view_bank-deposit">
          <Section name="Transactions">
            <Transactions
              userId={id}
              ref={this.transactionsInstance}
              filteredTransactionId={
                state && state.transactionId ? state.transactionId : null
              }
            />
          </Section>
        </Rbac>
        <Rbac permission="view_user-bank-accounts">
          <Section name="Bank Accounts">
            {application.platformName === "zarindax" ? (
              <BankInfo
                userId={id}
                filteredCardNumber={
                  state && state.cardNumber ? state.cardNumber : null
                }
                filteredIbanNumber={state && state.iban ? state.iban : null}
              />
            ) : (
              <BankAccounts
                userId={id}
                filteredAccountNumber={
                  state && state.accountNumber ? state.accountNumber : null
                }
              />
            )}
          </Section>
        </Rbac>
        <Rbac permission="view_user-orders">
          <Section name="Orders">
            <Orders
              userId={id}
              profile={profile}
              wallets={wallets}
              fetchWallets={this.fetchWallets}
            />
          </Section>
        </Rbac>
        <Rbac permission="view_user-trades">
          <Section name="Trades">
            <Trades userId={id} />
          </Section>
        </Rbac>
        <Rbac permission="view_tickets">
          <Section name="Tickets">
            <Tickets userId={id} />
          </Section>
        </Rbac>
        {!application.supportV2 && (
          <Rbac permission="view_user-notifications">
            <Section name="Notifications">
              <UserPrivateNotifications
                userId={id}
                history={this.props.history}
              />
            </Section>
          </Rbac>
        )}
        {application.supportV2 && (
          <Rbac permission="view_gift">
            <Section name="Gift Cards">
              <UserGifts userId={id} />
            </Section>
          </Rbac>
        )}
        {application.supportV2 && (
          <Rbac permission="view_bonus-policy">
            <Section name="Bonus Cards">
              <UserBonuses userId={id} />
            </Section>
          </Rbac>
        )}
        <Rbac permission="view_user-referrals">
          <Section name="Referrals">
            <UserReferrals
              userId={id}
              profile={profile}
              maxPlanableReferral={
                settings ? Number(settings["MAX-PLANABLE-REFERRAL"]) : null
              }
            />
          </Section>
        </Rbac>
        {/*{application.supportV2 &&*/}
        {/*  <Rbac permission="view_user-bots">*/}
        {/*    <Section name='Trading Bots'>*/}
        {/*      <UserBots userId={id}/>*/}
        {/*    </Section>*/}
        {/*  </Rbac>*/}
        {/*}*/}
        {application.supportV2 && (
          <Rbac permission="view_notification">
            <Section name="Notifications">
              <UserNotifications userId={id} history={this.props.history} />
            </Section>
          </Rbac>
        )}
        {application.supportV2 && (
          <Rbac permission="view_user-alerts">
            <Section name="Alerts">
              <UserAlerts userId={id} history={this.props.history} />
            </Section>
          </Rbac>
        )}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            padding: "10px 20px",
            fontSize: 12,
            color: "#666",
          }}
        >
          {i18n.t("Version")}: 1.0.0
        </div>
      </Fragment>
    );
  }
}

export default Info;
